export const beneficiaryCommentsTranslations = {
    en: {
        // Page Title
        commentsFor: "Comments for",
        selectCamp: "Select Camp",

        // Autocomplete
        selectVisitedCamp: "Select Visited Health Camp",
        unknown: "Unknown",
        unknownAddress: "Unknown Address",

        // Comment Form
        addCommentPlaceholder: "Add a comment...",
        comment: "Comment",

        // Messages
        commentError: "Failed to store comment",
        noCommentsYet: "No comments yet."
    },
    mr: {
        // Page Title
        commentsFor: "यासाठी टिप्पण्या",
        selectCamp: "शिबिर निवडा",

        // Autocomplete
        selectVisitedCamp: "भेट दिलेले आरोग्य शिबिर निवडा",
        unknown: "अज्ञात",
        unknownAddress: "अज्ञात पत्ता",

        // Comment Form
        addCommentPlaceholder: "टिप्पणी जोडा...",
        comment: "टिप्पणी",

        // Messages
        commentError: "टिप्पणी संग्रहित करण्यात अयशस्वी",
        noCommentsYet: "अद्याप टिप्पण्या नाहीत."
    }
};
